import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import React, { useEffect, useState } from "react";
import { convertToMoney } from "../utils/number";
import { formatDate } from "../utils/moment";
import {
  getEstadosCuenta,
  getReporteEstadoCuenta,
} from "../services/dashboard";

import { Link } from "react-router-dom";
import WithMainLayout from "../hocs/layouts/MainLayout";
import { useAPIs } from "../apis/APIsConfig";
import { useDocTitle } from "../utils/hooks";
import { useGlobalStore } from "../utils/global";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const Dashboard = () => {
  useDocTitle("Estado de Cuenta");
  useAPIs();

  const { user, showLoading, hideLoading } = useGlobalStore();
  const [list, setlist] = useState<any[]>([]);

  useEffect(() => {
    getEstadosCuenta().then((resumen) => {
      if (resumen) {
        setlist(resumen.data.value);
      }
    });
  }, []);

  function download(fechaCorte) {
    getReporteEstadoCuenta(fechaCorte);
  }

  return (
    <>
      <div className="block pt-10 lg:pt-8 pb-[128px]">
        <nav className="pb-8 lg:pb-14">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Mi cuenta</Link>
            </li>
            <li className="breadcrumb-item active">Estado de Cuenta</li>
          </ol>
        </nav>
        <ul className="info-card-download">
          {list.map((item, index) => (
            <li key={index}>
              <div>
                <div className="icon-container">
                  <i className="icon icon-cash text-primary-90 text-[20px]"></i>
                </div>
                <div className="description">
                  <p>Al corte {formatDate(item.fechaCorte, "DD-MM-YYYY")}</p>
                  <h5 className="lead font-semibold">
                    RD$ {convertToMoney(item.monto)}
                  </h5>
                </div>
              </div>
              <button
                onClick={() => download(item.fechaCorte)}
                className="btn btn-secondary btn-medium hidden lg:inline-flex"
              >
                Descargar
              </button>
              <button
                className="block lg:hidden"
                onClick={() => download(item.fechaCorte)}
              >
                <i className="icon icon-download text-gray-50 text-[26px]"></i>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default WithMainLayout(Dashboard, "Estado de Cuenta");
